import { firebaseDb, ServerTimestamp } from '../firebase'
import { reset } from 'redux-form';
import { addNotification } from './notification'
import history from '../history'

export const loadDocuments = () => (
  dispatch => {
    firebaseDb.collection('documents').orderBy('title').onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_DOCMENTS',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)
export const documentFormSubmit = values => (
  dispatch => {
    values.docId?
      dispatch(updateDocument(values))
    :
      dispatch(addDocument(values))
  }
)
export const addDocument = values => (
  dispatch => {
    firebaseDb.collection('documents').add({
      title: values.title? values.title : 'No title',
      text: values.text,
      uid: values.uid,
      updated: ServerTimestamp 
    })
    .then(docRef => {
      dispatch(reset('document'))
      dispatch(addNotification("更新しました", "success"))
      history.push('/document/' + docRef.id)
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("更新に失敗しました", "error"))
    })
  }
)
export const updateDocument = values => (
  dispatch => {
    firebaseDb.collection('documents').doc(values.docId).update({
      title: values.title? values.title : 'No title',
      text: values.text,
      uid: values.uid,
      updated: ServerTimestamp 
    })
    .then(() => {
      dispatch(reset('document'))
      dispatch(addNotification("更新しました", "success"))
      history.push('/document/' + values.docId)
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("更新に失敗しました", "error"))
    })
  }
)
export const deleteDocument = id => (
  dispatch => {
    firebaseDb.collection('documents').doc(id).delete()
    .then(() => {
      dispatch(reset('document'))
      dispatch(addNotification("削除しました", "success"))
      history.push('/document')
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("削除に失敗しました", "error"))
    })
  }
)


// WEBPACK FOOTER //
// ./src/actions/documents.js